import {
  isDraftSpecialTextConfiguration,
  isDraftTextOrPlaceHolderTextConfiguration,
} from '@/model/configuration/isDraftConfigurationType';
import { printTypesForSpecialText } from '@/model/printType/printTypesForSpecialText';
import { getCurrentAppearance } from '@/redux/draft/getters/getCurrentAppearance';
import { getSelectedConfiguration } from '@/redux/draft/getters/getSelectedConfiguration';
import { StoreState } from '@/redux/types';
import { getAreSpecialFontsAvailable } from './getAreSpecialFontsAvailable';
import { getSpecialFonts } from './getSpecialFonts';

export const getSpecialFontsForCurrentConfiguration = (state: StoreState) => {
  if (getAreSpecialFontsAvailable(state)) {
    const currentConfiguration = getSelectedConfiguration(state);
    if (
      (isDraftTextOrPlaceHolderTextConfiguration(currentConfiguration) ||
        isDraftSpecialTextConfiguration(currentConfiguration)) &&
      printTypesForSpecialText(currentConfiguration.printArea, getCurrentAppearance(state)).length >
        0
    ) {
      return getSpecialFonts(state);
    }
  }

  return [];
};
